import React, { useState } from "react";
import styled from "styled-components";
import MainMenu from "../Components/Main_Menu";
import StoryFeed from "../Components/StoryFeed";
import RecommendFriend from "../Components/RecommendFriend";
import Feed from "../Components/Feed";
import SearchContentInput from "../Components/SearchContent";

const Search = () => {
  const [isSerarchBtnclike, setIsSerarchBtnclike] = useState(false);

  const searchBtnClicked = () => {
    setIsSerarchBtnclike((prev) => !prev); // 토글 방식으로 상태 업데이트
  };

  return (
    <SearchWrap>
      <MainMenu
        searchBtnClicked={searchBtnClicked}
        setIsSerarchBtnclike={setIsSerarchBtnclike}
      />

      <SearchContentWrap style={{ width: isSerarchBtnclike ? "300px" : "0" }}>
        <SearchContentInput />
      </SearchContentWrap>
    </SearchWrap>
  );
};

export default Search;

const SearchWrap = styled.div`
  position: relative;
  width: 100%;
`;

const HomeContentWrap = styled.div`
  width: calc(100% - 240px);
  position: relative;
  left: 240px;
  display: flex;

  @media (max-width: 1264px) {
    width: calc(100% - 80px);
    left: 90px;
  }
  @media (max-width: 767px) {
    width: 100%;
    left: 0;
  }
`;

const FeedWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    margin-top: 70px;
  }
`;

const SearchContentWrap = styled.div`
  position: fixed;
  height: 100vh;
  left: 240px;
  top: 0;
  transition: all 0.5s;
  overflow: hidden;
  white-space: nowrap;
  z-index: 10;

  @media (max-width: 1264px) {
    width: 400px;
    left: 80px;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SearchContent = styled.div``;
